var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-ag-grid',{attrs:{"title":"Renewal Payments","columnDefs":_vm.columnDefs,"rowData":_vm.renewalPayments,"loading":_vm.loading,"getRowStyle":_vm.getRowStyle,"mobileCard":_vm.mobileCard,"newBtn":false},on:{"refresh":_vm.fetchRenewalPayments,"row-dbl-click":(data) => _vm.$router.push({ path: `renewal-payments/${data._id}/view` })}})
}
var staticRenderFns = []

export { render, staticRenderFns }